import { render } from "./ThePreloader.vue?vue&type=template&id=71dbd0b6"
import script from "./ThePreloader.vue?vue&type=script&lang=js"
export * from "./ThePreloader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__